import React from "react";
import i18n from "../../i18n";
import { Form } from "react-bootstrap";

const LanguageSwitcher = () => {
  const currentLang =
    i18n.language || localStorage.getItem("i18nextLng") || "en";

  const changeLanguage = (lang) => {
    // console.log(lang, "===== selected language =====>");
    localStorage.setItem("i18nextLng", lang);
    i18n.changeLanguage(lang);
  };

  return (
    <div className="relative">
      <p className="mb-0 fw-semibold">Language </p>

      <Form.Select
        style={{ width: 150 }}
        value={currentLang}
        onChange={(e) => changeLanguage(e.target.value)}
        className="shadow-sm mb-1"
      >
        <option value="en">English</option>
        <option value="th">Thai</option>
        <option value="vi">Vietnamese</option>
      </Form.Select>

    </div>
  );
};

export default LanguageSwitcher;
